<span class="icon-inline" v-tooltip.bottom="tooltipOptions">
  <ChessBughouseSvg preserveAspectRatio="xMidYMid meet" :style="svgStyle" />
</span>
